import { useContext } from "react";

import ArtworkDataContext from "@/context/ArtworkDataContext";
import LikeIcon from "@/shared-components/icons/components/actions/LikeIcon";
import FillableThoughtIcon from "@/shared-components/icons/components/artwork/FillableThoughtIcon";
import RatingIcon from "@/shared-components/icons/components/artwork/RatingIcon";
import SuarteName from "@/shared-components/icons/components/public/SuarteName";

import "./styles/TemplatePreview.css";

const TemplatePreview = ({ croppedUrl, templateColor, templateType, reference }) => {
  const { artworkData } = useContext(ArtworkDataContext);
  const {
    artwork_gallery: {
      user_name: galleryName,
      gallery_address: { country, region },
    },
    artwork_gallery_artist: {
      artist_name: artistName,
      artist_nationality: artistNationality,
      artist_birth: artistYear,
    },
    artwork_title: artworkTitle,
    artwork_year: artworkYear,
    artwork_medium: artworkMedium,
    artwork_size: { height: artworkHeight, length: artworkWidth, unit },
  } = artworkData.artwork_about;

  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  const templateColorTheme = getComputedStyle(document.documentElement).getPropertyValue(`--app-${templateColor}_theme`);

  return (
    <div ref={reference} className={`artwork-preview-container-${templateType}`}>
      <div className={`artwork-preview-header-${templateType}`} >
        <SuarteName className="artwork-preview-header__suarte-img" />
      </div>
      <img src={croppedUrl} className={`artwork-download-template-img-${templateType}`} />
     
      <div className={`artwork-preview-info-container-${templateType}`}>
        <div className="artwork-preview-gradient"></div>
        <div className="artwork-preview-gallery-info">
          <div className="artwork-preview-gallery-info__name-country">
            <p className="artwork-preview-gallery-info__gallery-name" style={{ color: templateColorTheme }}>{truncateText(galleryName,40)}</p>
            <p className="artwork-preview-gallery-info__gallery-location">{`${region}, ${country}`}</p>
          </div>
        </div>

        <div className="artwork-preview-artwork-info">
          <div className="artwork-preview-artist-info">
            <p className="artwork-preview-artist-info__artist-name" style={{ color: templateColorTheme }}>{truncateText(artistName,40)}</p>
            <p className="artwork-preview-artist-info__artist-location">{`${artistNationality}, ${artistYear}`}</p>
          </div>
          <div className="artwork-preview-artwork-section">
            <p className="artwork-preview-artwork-section__artwork-name">{truncateText(artworkTitle,40)}</p>
            <div className="artwork-preview-artwork-section__artwork-data">
              <p>{artworkMedium}</p>
              <p>{`${artworkHeight} ${unit} x ${artworkWidth} ${unit}`}</p>
              <p>{artworkYear}</p>
            </div>
          </div>

          <div className="artwork-preview-artwork-info__icons" style={{ stroke: templateColorTheme }}>
            <RatingIcon border={templateColorTheme} fill={"none"} />
            <FillableThoughtIcon border={templateColorTheme} fill={"none"} />
            <LikeIcon border={templateColorTheme} fill={"none"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplatePreview;
